import { Metamodel } from 'app/model/base/model';
import { CosmosSqlSettings, CosmosDBStoreType } from './cosmos-sql-settings';
import { DatasetFormatType } from './dataflow-dataset-settings';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.cosmosMongo.dataflowSettings,
})

export class CosmosMongoSettings extends CosmosSqlSettings {

    public override storeType: CosmosDBStoreType = CosmosDBStoreType.Analytical;

    public override getFormat(): DatasetFormatType {
        return DatasetFormatType.CosmosDBMongo;
    }

}
